import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
    // Redireccionamiento raíz
    {
        path: '',
        redirectTo: 'modules/dashboard',
        pathMatch: 'full'
    },

    // Reserva pública: deliberadamente no usa authGuard ni noAuthGuard.
    {
        path: 'reservar/:token',
        loadComponent: () => import('./public-booking/public-booking.component').then((m) => m.PublicBookingComponent)
    },

    // Rutas de autenticación (sin layout)
    {
        path: 'auth',
        canActivate: [noAuthGuard],
        loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes)
    },

    // Rutas protegidas (con layout principal)
    {
        path: 'modules',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/layout/layout.component').then((m) => m.LayoutComponent),
        children: [
            {
                path: 'dashboard',
                loadComponent: () => import('./modules/dashboard/dashboard.component').then((m) => m.DashboardComponent)
            },
            // ── Organización (SUPER_ADMIN gestiona todo; ADMIN solo su empresa) ──
            {
                path: 'company',
                loadChildren: () => import('./modules/company/company.routes').then((m) => m.companyRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'] }
            },
            {
                path: 'branch',
                loadChildren: () => import('./modules/branch/branch.routes').then((m) => m.branchRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'] }
            },
            // ── Catálogos ─────────────────────────────────────────────────────
            {
                path: 'dentist',
                loadChildren: () => import('./modules/dentist/dentist.routes').then((m) => m.dentistRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'] }
            },
            {
                path: 'treatment-catalog',
                loadChildren: () => import('./modules/treatment-catalog/treatment-catalog.routes').then((m) => m.treatmentCatalogRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'] }
            },
            {
                path: 'stamps',
                loadChildren: () => import('./modules/stamps/stamps.routes').then((m) => m.stampsRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'] }
            },
            // ── Pacientes y agenda ────────────────────────────────────────────
            {
                path: 'patients',
                loadChildren: () => import('./modules/patients/patients.routes').then((m) => m.patientsRoutes)
            },
            {
                path: 'odontogram',
                loadChildren: () => import('./modules/odontogram/odontogram.routes').then((m) => m.odontogramRoutes)
            },
            {
                path: 'scheduling',
                loadChildren: () => import('./modules/scheduling/scheduling.routes').then((m) => m.schedulingRoutes)
            },
            // ── Clínica ───────────────────────────────────────────────────────
            {
                path: 'treatment-plan',
                loadChildren: () => import('./modules/treatment-plan/treatment-plan.routes').then((m) => m.treatmentPlanRoutes)
            },
            {
                path: 'performed-treatments',
                loadChildren: () => import('./modules/performed-treatments/performed-treatments.routes').then((m) => m.performedTreatmentsRoutes)
            },
            // ── Facturación ───────────────────────────────────────────────────
            {
                path: 'invoicing',
                loadChildren: () => import('./modules/invoicing/invoicing.routes').then((m) => m.invoicingRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_DOCTOR', 'ROLE_SECRETARY'] }
            },
            {
                path: 'receipts',
                loadChildren: () => import('./modules/receipts/receipts.routes').then((m) => m.receiptsRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_DOCTOR', 'ROLE_SECRETARY'] }
            },
            {
                path: 'cash-book',
                loadChildren: () => import('./modules/cash-book/cash-book.routes').then((m) => m.cashBookRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_DOCTOR', 'ROLE_SECRETARY'] }
            },
            // ── Reportes ──────────────────────────────────────────────────────
            {
                path: 'reports',
                loadChildren: () => import('./modules/reports/reports.routes').then((m) => m.reportsRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_DOCTOR', 'ROLE_SECRETARY'] }
            },
{
                path: 'public-booking',
                loadChildren: () => import('./modules/public-booking/public-booking.routes').then((m) => m.publicBookingRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_SECRETARY', 'ROLE_DOCTOR'] }
            },
            {
                path: 'email-templates',
                loadChildren: () => import('./modules/email-templates/email-templates.routes').then((m) => m.emailTemplatesRoutes),
                canActivate: [roleGuard],
                data: { roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_SECRETARY'] }
            },
            // fallback interno
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
        ]
    },

    // Páginas de error (sin guard)
    {
        path: 'access-denied',
        loadComponent: () => import('./shared/components/accessdenied/accessdenied.component').then((m) => m.AccessdeniedComponent)
    },
    {
        path: 'not-found',
        loadComponent: () => import('./shared/components/notfound/notfound.component').then((m) => m.NotfoundComponent)
    },

    // Catch-all
    { path: '**', redirectTo: 'not-found' }
];
